<template>
    <div class="info-guide-overlay">
        <div class="dot"></div>
    </div>
</template>

<script>
export default {
    name: 'InfoIcon',
};
</script>

<style scoped lang="scss">
.info-guide-overlay {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background-color: rgba(13, 180, 230, 0.2);
    margin-right: 8px;
    -webkit-animation: breathing 2.5s ease-out infinite normal;
    animation: breathing 2.5s ease-out infinite normal;

    .dot {
        background-color: #5bc5e4;
        width: 13.75px;
        height: 13.75px;
        border-radius: 50%;
        -webkit-animation: breathing 2.5s ease-out infinite normal 1s;
        animation: breathing 2.5s ease-out infinite normal 1s;
    }
}

@-webkit-keyframes breathing {
    0% {
        -webkit-transform: scale(0.9);
        transform: scale(0.9);
    }

    25% {
        -webkit-transform: scale(1.2);
        transform: scale(1.2);
    }

    60% {
        -webkit-transform: scale(0.9);
        transform: scale(0.9);
    }

    100% {
        -webkit-transform: scale(0.9);
        transform: scale(0.9);
    }
}

@keyframes breathing {
    0% {
        -webkit-transform: scale(0.9);
        -ms-transform: scale(0.9);
        transform: scale(0.9);
    }

    25% {
        -webkit-transform: scale(1.2);
        -ms-transform: scale(1.2);
        transform: scale(1.2);
    }

    60% {
        -webkit-transform: scale(0.9);
        -ms-transform: scale(0.9);
        transform: scale(0.9);
    }

    100% {
        -webkit-transform: scale(0.9);
        -ms-transform: scale(0.9);
        transform: scale(0.9);
    }
}
</style>
